import React, { useEffect, useState } from 'react';
import { Alert, Grid, Typography } from '@mui/material';
import { CrmButton, CrmSelect } from '../ui';
import { CURRENCIES, DATE_FORMATS, GLOBAL_DEFAULTS } from './settingsFormUtils';

const currencyLabel = (currency) => `${currency.code} — ${currency.name}`;

export default function SettingsForm({ settings, onSubmit }) {
  const [form, setForm] = useState({ currency_code: GLOBAL_DEFAULTS.currencyCode || '', date_format: GLOBAL_DEFAULTS.dateFormat || '', gst_pricing_mode: 'EXCLUSIVE' });

  useEffect(() => {
    setForm({
      currency_code: settings?.currency_code || GLOBAL_DEFAULTS.currencyCode || '',
      date_format: settings?.date_format || GLOBAL_DEFAULTS.dateFormat || '',
      gst_pricing_mode: String(settings?.gst_pricing_mode || 'EXCLUSIVE').toUpperCase(),
    });
  }, [settings]);

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(form);
  };

  return (
    <>
      <Typography variant="h5" fontWeight={700} mb={1}>Dashboard Preferences</Typography>
      <Typography color="text.secondary" mb={2}>
        These values control how amounts and dates are displayed across the dashboard. Company, tax and brand identity now live in Business Structure.
      </Typography>
      <Alert severity="info" sx={{ mb: 3 }}>
        Legal names, GSTIN/PAN, addresses, brands, business units and storefront identity are managed under Business Structure instead of the legacy organization settings.
      </Alert>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <CrmSelect label="Display Currency" name="currency_code" value={form.currency_code} onChange={(event) => setForm((previous) => ({ ...previous, currency_code: event.target.value }))}>
              {CURRENCIES.map((currency) => <option key={currency.code} value={currency.code}>{currencyLabel(currency)}</option>)}
            </CrmSelect>
          </Grid>
          <Grid item xs={12} md={6}>
            <CrmSelect label="Date Format" name="date_format" value={form.date_format} onChange={(event) => setForm((previous) => ({ ...previous, date_format: event.target.value }))} helperText="Used across dashboard tables, filters, record pages and settings forms.">
              {DATE_FORMATS.map((format) => <option key={format} value={format}>{format}</option>)}
            </CrmSelect>
          </Grid>
          <Grid item xs={12} md={6}>
            <CrmSelect label="Product / Service Price GST Basis" name="gst_pricing_mode" value={form.gst_pricing_mode} onChange={(event) => setForm((previous) => ({ ...previous, gst_pricing_mode: event.target.value }))} helperText="Inclusive means entered selling prices already contain GST. Exclusive means GST is added on top. Quotations, storefront checkout and Tax Invoices use this same basis; Proforma keeps the commercial price basis but does not charge tax.">
              <option value="INCLUSIVE">Inclusive of GST</option>
              <option value="EXCLUSIVE">Exclusive of GST</option>
            </CrmSelect>
          </Grid>
          <Grid item xs={12}>
            <CrmButton variant="primary" type="submit">Save Preferences</CrmButton>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
